import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import LinearProgress from '@mui/material/LinearProgress';
import {KeyboardArrowDown,KeyboardArrowUp} from '@mui/icons-material'

const PaginatedTable=(props)=>
{
    return (<Table>
        <TableHead>
          <TableRow>
            {props.columns.map(column=><TableCell onClick={()=>{
              if(column.sortable)
                column.onClick()
            }} {...column.properties}>{column.name}{column.sortable&&<span>{(column.asc?<KeyboardArrowDown />:<KeyboardArrowUp />)}</span>}</TableCell>)}
          </TableRow>
        </TableHead>
        <TableBody>
        {!props.loading&&props.rows.map(row=><TableRow {...row.properties}>{row.columns.map(column=><TableCell {...column.properties}>
               {column.value}
              </TableCell>)}
        </TableRow>)}
        {!props.loading&&props.rows.length===0&&<TableRow key="1">
            <TableCell colSpan={props.columns.length} align="center">
            {props.emptyMessage?props.emptyMessage:"No records found"}
            </TableCell>
        </TableRow>}
        {props.loading&&<TableRow key="2">
            <TableCell colSpan={props.columns.length} align="center">
                <LinearProgress className="progressbar" color="primary" />
            </TableCell>
        </TableRow>}
        </TableBody>
        {props.count>0&&<TableFooter>
              <TableRow className="mobile-left">
                <TablePagination
                  rowsPerPageOptions={props.pageOptions?props.pageOptions:[20]}
                  colSpan={props.columns.length}
                  count={props.count}
                  rowsPerPage={props.pageSize?props.pageSize:20}
                  page={props.page?props.page:0}
                  SelectProps={{
                    native: true,
                  }}
                  onPageChange={(event, page)=>props.goToPage(page)}
                  onChangeRowsPerPage={(event)=>{
                      if(props.pageOptions&&props.pageOptions.length>1)
                        props.onRowsPerPage(event.target.value)
                    }}
                />
              </TableRow>
            </TableFooter>}
      </Table>)
}
export default PaginatedTable;